<template>
        <div class="scrollableY cmsInAccWidther has-text-white pad10 has-text-centered" style="z-index: 0">
         
           <br><br><br>
            <!--  <div class="has-text-left top20 is-size-2">ACCOUNT SETTINGS</div> -->
              <div class="has-background-dark top40 pad10 wideLimitWidth colorLeft has-text-centered roundedCorners is-size-3 marginAutod">
                <div class="is-size-4">You've created:</div>
                <div><b class="has-text-coolGreen">{{parseInt(bCount).toLocaleString()}}</b> Bundles and <b class="has-text-coolGreen">{{parseInt(mCount).toLocaleString()}}</b> Miimus</div> 
              </div>

              <div class="top40 is-size-4">
                <b>In order to create more than <b class="has-text-coolGreen">20 bundles</b> or <b class="has-text-coolGreen">200 miimus</b> you must upgrade your plan</b>
              </div>
              <br>
              <div class="top40 is-size-4 wideLimitWidth marginAutod">
                When you upgrade you also get access to the Collab Network, so you can work on bundles collaboratively with other users, and you can choose to hide the ads!
              </div>

              <button class="button is-coolGreen top40" @click="$router.push('/upgrade')"><b>Upgrade Now!</b></button>

       
        </div>
</template>

<script>
import countries from '../static/countries.js'
import { AZEventBus } from './AZEventBus.js';
var AmazonCognitoIdentity = require('amazon-cognito-identity-js')
import footerDiv from './Footer.vue'

export default{
  components: {footerDiv},
  data: function () {
    var form = {
      fName: '',
      lName: '',
      /* company: '', */
      phone: '',
      shipAddress1: '',
      shipAddress2: '',
      shipCity: '',
      shipState: '',
      shipZip: '',
      shipCountry: '',
     
    }

    var form2 = {
      oldPassword: '',
      password: ''
    }

    var form3 = {
      email: ''
    }

    return {
      form: form,
      form2: form2,
      form3: form3,
      showForm: true,
      successMessage: '',
      countries: countries,
      inited: false,
      bCount: 0,
      mCount: 0
    }
  },
  /* watch: { // when /accsettings page is refreshed or freshly loaded sesson is checked, must refresh attr values:
    '$root.userAttrs': function (newVal, oldVal) {
      this.form.fName = this.$root.userAttrs.given_name,
      this.form.lName = this.$root.userAttrs.family_name,
      this.form.company = this.$root.userAttrs['custom:company'],
      this.form.city = this.$root.userAttrs['custom:city'],
      this.form.country = this.$root.userAttrs['custom:countryCode']
    }
  }, */
  mounted: function () {
   
      //get account values from DB
       var self = this;
        self.worked = function (data) {
            az.addRemSpinner(false, 'id', 'form1');
            var obj = data.response[0];
            for(var i in obj){
                self.form[i] = obj[i];
            }

            self.mCount = data.assets.m
            self.bCount = data.assets.b
        }
        self.noWorked = function (data, status, headers, config, msg, errorRequest) {
            az.addRemSpinner(false, 'id', 'form1');
            //self.$root.showModalOK({message: data})
        }

        function init(){
            self.$root.app.apiClient.get('auth/account', {}, self.worked, self.noWorked);
        }

        az.addRemSpinner(true, 'id', 'form1');

        if(self.$root.app.doneFederating){
            self.inited = true
            init();
        }

        AZEventBus.$once('onFederate', msg => {
          if(self.inited == false)
            init();
        });
  },

  beforeDestroy: function(){
    AZEventBus.$off('onFederate')
  },

  methods: {
    submitForm1: function () {
      var self = this
      this.$validator.validateAll('form1').then((res) => {
        if (res) {
          updateDB()
        } else {
          this.$root.app.showModalOK({message: 'Please correct the errors on the form'})
        }
      })

      function updateDB(){
        az.addRemSpinner(true, 'id', 'save1');
        function worked(data) {
            if(data.statusCode == '406'){
                az.addRemSpinner(false, 'id', 'save1');
                az.addRemSpinner(false, 'id', 'form1');
                self.$root.app.showModalOK({message: 'DB Error: There was an error updating your information.'})
                return;
            }
            /* az.addRemSpinner(false, 'id', 'form1');
            var obj = data.response[0];
            for(var i in obj){
                self.form[i] = obj[i];
            } */
            //updateAttrs();
            self.successMessage = 'Your personal information has been successfully updated.'
            self.showForm = false
            az.addRemSpinner(false, 'id', 'form1');  
            az.addRemSpinner(false, 'id', 'save1');
        }
        function noWorked(data, status, headers, config, msg, errorRequest) {
            az.addRemSpinner(false, 'id', 'form1');
            //self.$root.showModalOK({message: data})
        }

        az.addRemSpinner(true, 'id', 'form1');
        self.$root.app.apiClient.put('auth/account', self.form, worked, noWorked);

      }

      /* function updateAttrs () {
        az.addRemSpinner(false, 'id', 'form1');  
        

        var attributes = [
          {Name: 'given_name', Value: self.form.fName},
          {Name: 'family_name', Value: self.form.lName},
        ]

        self.$root.azCognito.updateAttributes(attributes, updateAttrsCallback)

        function updateAttrsCallback (result, obj) {
          az.addRemSpinner(false, 'id', 'save1');
          
          if (result == 'success') {
            self.successMessage = 'Your personal information has been successfully updated.'
            self.showForm = false

            for (var i = 0; i < attributes.length; i++) {
              self.$root.userAttrs[attributes[i].Name] = attributes[i].Value
            }
          } else if (result == 'error') {
            self.$root.showModalOK({message: 'There was an error updating your information.'})
          }
        }
      } */
    },
    submitForm2: function () {
      var self = this
      this.$validator.validateAll('form2').then((res) => {
        if (res) {
          // this.showForm = false;
          changePassword()
        } else {
          this.$root.app.showModalOK({message: 'Please correct the errors on the form'})
        }
      })

      function changePassword () {
        az.addRemSpinner(true, 'id', 'save2');

        self.$root.app.azCognito.changePassword(self.form2.oldPassword, self.form2.password, changePasswordCallback)

        function changePasswordCallback (result, err) {
          az.addRemSpinner(false, 'id', 'save2');
          if (result == 'error') {
            if (err.code == 'InvalidParameterException' || err.code == 'NotAuthorizedException') {
              self.$root.app.showModalOK({message: 'The old password you provided is incorrect. You may use the Forgot Password procedure after logging out if you have forgotten it.'})
            } else if (err.code == 'LimitExceededException') {
              self.$root.app.showModalOK({message: 'The attempts limit has been reached, please try again later'})
            }
            return
          }
          self.successMessage = 'Your password has been successfully updated.'
          self.showForm = false
          window.scrollTo(0, 0)
        }
      }
    },
    submitForm3: function () {
      var self = this
      this.$validator.validateAll('form3').then((res) => {
        if (res) {
          updateEmail()
        } else {
          this.$root.showModalOK({message: 'Please correct the errors on the form'})
        }
      })

      function updateEmail () {
        az.addRemSpinner(true, 'id', 'save3');

        var attributes = [
          {Name: 'email', Value: self.form3.email}
        ]

        self.$root.app.azCognito.updateEmail(attributes, updateEmailCallback)

        function updateEmailCallback (result, obj) {
          az.addRemSpinner(false, 'id', 'save3');
          if (result == 'error') {
            if (obj.code == 'AliasExistsException') {
              self.$root.app.showModalOK({message: 'The email provided is already in use! please provide a different one.'})
            } else {
              self.$root.app.showModalOK({message: 'There was an error updating your information.'})
            }
            return
          }

           //cog success: update local attributes and do db call here
    
            self.successMessage = 'We have sent a confirmation email to ' + self.form3.email + ' with a code. Please log back in with your the new email address and provide the code we sent you when prompted.'
            self.showForm = false
            self.$root.app.isAuth = false

            for (var i = 0; i < attributes.length; i++) {
                self.$root.app.userAttrs[attributes[i].Name] = attributes[i].Value
            }

            function worked(data) {
                if(data.statusCode == '406'){
                    //TODO: consider sending admin notification saying congito email was not synced to DB
                }
            }
            function noWorked(data, status, headers, config, msg, errorRequest) {
                    //TODO: consider sending admin notification saying congito email was not synced to DB
            }
            self.$root.app.apiClient.put('auth/account', {email: self.form3.email}, worked, noWorked);
        }
      }
    }
  }
}
</script>

<style scoped>
  input{
    background-color: #333;
    border: none;
    border-bottom: 1px solid #f1c232;
    color: white
  }
</style>

